import { useChangeRegionStatus } from '../hooks/useChangeRegionStatus';
import { ConfirmDialog } from '@/shared/components/ahkinia/ConfirmDialog/ConfirmDialog';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';

interface ToggleRegionStatusModalProps {
  regionId: string;
  regionName: string;
  currentIsActive: boolean;
  onClose: () => void;
}

export function ToggleRegionStatusModal({
  regionId,
  regionName,
  currentIsActive,
  onClose,
}: ToggleRegionStatusModalProps) {
  const { updateStatus, isUpdating } = useChangeRegionStatus();

  const isDisabling = currentIsActive;

  const handleConfirm = async () => {
    try {
      await updateStatus({ id: regionId, isActive: !currentIsActive });
      Notification.success({
        title: isDisabling ? 'Región deshabilitada exitosamente' : 'Región habilitada exitosamente',
      });
      onClose();
    } catch {
      // global error handler shows the error; dialog stays open for retry
    }
  };

  return (
    <ConfirmDialog
      open
      onOpenChange={(v) => {
        if (!v && !isUpdating) onClose();
      }}
      title="Cambiar estado de región"
      description={
        <span data-testid="toggle-region-status-message">
          {isDisabling ? (
            <>
              ¿Estás seguro de deshabilitar la región <strong>{regionName}</strong>?
            </>
          ) : (
            <>
              ¿Estás seguro de habilitar la región <strong>{regionName}</strong>?
            </>
          )}
        </span>
      }
      onConfirm={handleConfirm}
      confirmLabel={isDisabling ? 'Deshabilitar' : 'Habilitar'}
      confirmLoadingLabel={isDisabling ? 'Deshabilitando...' : 'Habilitando...'}
      isPending={isUpdating}
      data-testid="toggle-region-status-modal"
    >
      {isDisabling ? (
        <div className="p-3 bg-destructive/10 border border-destructive/30 rounded-md">
          <p className="text-sm text-destructive font-medium">
            Advertencia: Esto afectará las regiones hijas asociadas.
          </p>
        </div>
      ) : (
        <div className="p-3 bg-primary/10 border border-primary/30 rounded-md">
          <p className="text-sm text-primary">
            Nota: También se habilitarán todas las regiones hijas deshabilitadas.
          </p>
        </div>
      )}
    </ConfirmDialog>
  );
}
